import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import type { DocumentType } from '#src/__generated__/globalTypes.ts';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { HeadlineL, HeadlineXS } from '#src/atoms/typography/index.tsx';
import { FilePreview } from '#src/components/fiatWallet/CreateFiatWallet/DocumentCheck/UploadInput/index.tsx';
import { StepWrapperFromProps } from '#src/components/fiatWallet/CreateFiatWallet/StepWrapper/index.tsx';
import { documentNameByType } from '#src/components/fiatWallet/UnblockWallet/type.ts';
import type { FileWithDataURL } from '#src/components/form/UploadFile/useUploadFile.ts';

export const Review = ({
  requiredDocumentsFiles,
  submitButton,
  onBack,
}: {
  requiredDocumentsFiles: {
    [key in DocumentType]?: FileWithDataURL[];
  };
  submitButton: ReactNode;
  onBack: () => void;
}) => {
  return (
    <StepWrapperFromProps onBack={onBack} submitButton={submitButton}>
      <HeadlineL>
        <FormattedMessage defaultMessage="Review your documents" />
      </HeadlineL>
      <HeadlineXS>
        <FormattedMessage defaultMessage="Before sending your documents, please review them to make sure they are correct." />
      </HeadlineXS>
      {Object.entries(requiredDocumentsFiles).map(([documentType, files]) => {
        return (
          <Vertical key={documentType}>
            <HeadlineXS>
              <FormattedMessage
                {...documentNameByType[documentType as DocumentType]}
              />
            </HeadlineXS>
            <Horizontal>
              {files.map((file, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <FilePreview key={i} file={file} />
              ))}
            </Horizontal>
          </Vertical>
        );
      })}
    </StepWrapperFromProps>
  );
};
